/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=11dd7a2e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=11dd7a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dd7a2e"]])

export default __exports__